import React from 'react';
import { Trans } from 'react-i18next';

import styles from './Step.module.css';

const Step = ({ icon, translationEntry = '' }) => (
  <div className={styles.stepCard}>
    <div className={styles.stepIcon}>
      <img
        alt=""
        className={styles.stepIcon}
        src={icon}
      />
    </div>

    <span className={styles.stepTitle}>
      <Trans
        components={{
          bold: <span className={styles.bold} />,
        }}
        i18nKey={translationEntry}
        ns="petDemos"
      />
    </span>
  </div>
);

export { Step };
